import { chatConstants } from '../constants';

const initialState = {
    loading: false,
    chatmessages: [],
    error: null
};

const chatReducer = (state = initialState, action) => {
    switch (action.type) {
        case chatConstants.FETCH_CHATMESSAGES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case chatConstants.FETCH_CHATMESSAGES_SUCCESS:
            return {
                ...state,
                loading: false,
                chatmessages: action.chatmessages,
                error: null
            };
        case chatConstants.FETCH_CHATMESSAGES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case chatConstants.SEND_CHATMESSAGE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case chatConstants.SEND_CHATMESSAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                chatmessages: action.chatmessages,
            };
        case chatConstants.SEND_CHATMESSAGE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload?.error || null,
            };
        case chatConstants.UPDATE_CHATMESSAGES:
            return {
                ...state,
                chatmessages: action.chatmessages
            };
        case chatConstants.APPEND_CHATMESSAGES: {
            const incoming = Array.isArray(action.chatmessages) ? action.chatmessages : [action.chatmessages];
            const existingIds = new Set((state.chatmessages || []).map(m => m.ChatMessageID ?? `${m.StudentProfileID}-${m.CreatedTimestamp}`));
            const toAppend = incoming.filter(m => !existingIds.has(m.ChatMessageID ?? `${m.StudentProfileID}-${m.CreatedTimestamp}`));
            if (toAppend.length === 0) return state;
            return {
                ...state,
                chatmessages: [...(state.chatmessages || []), ...toAppend]
            };
        }
        default:
            return state;
    }
};

export default chatReducer;
